export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";